var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 17,
    viewBox: "0 0 28 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8999 16.4L21.1499 1",
    stroke: "#677686",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8.59985C1.1625 8.78735 1.3625 9.01235 1.5875 9.26235C2.3 10.0374 3.3375 11.0624 4.6 12.0999C7.1875 14.1874 10.55 16.0999 14.125 16.0999C17.7 16.0999 21.0625 14.1874 23.65 12.0999C24.925 11.0749 25.95 10.0374 26.6625 9.26235C26.9 9.01235 27.1 8.78735 27.25 8.59985C27.0875 8.41235 26.8875 8.18735 26.6625 7.93735C25.95 7.16235 24.9125 6.13735 23.65 5.09985C21.0625 3.01235 17.7 1.09985 14.125 1.09985C10.55 1.09985 7.1875 3.01235 4.6 5.09985C3.325 6.12485 2.3 7.16235 1.5875 7.93735C1.35 8.18735 1.15 8.41235 1 8.59985Z",
    stroke: "#677686",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 12.5374C16.4101 12.5374 18.2625 10.7745 18.2625 8.59985C18.2625 6.42523 16.4101 4.66235 14.125 4.66235C11.84 4.66235 9.98755 6.42523 9.98755 8.59985C9.98755 10.7745 11.84 12.5374 14.125 12.5374Z",
    stroke: "#677686",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCloseIcon);
export default __webpack_public_path__ + "static/media/eye-close-icon.1255d2af76c13cfeb7cb0c94624ecb58.svg";
export { ForwardRef as ReactComponent };